function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Dot Menu Horizontal Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M2,13 C2.829,13 3.5,13.671 3.5,14.5 C3.5,15.329 2.829,16 2,16 C1.171,16 0.5,15.329 0.5,14.5 C0.5,13.671 1.171,13 2,13 Z M2,6.4644 C2.829,6.4644 3.5,7.1354 3.5,7.9644 C3.5,8.7924 2.829,9.4644 2,9.4644 C1.171,9.4644 0.5,8.7924 0.5,7.9644 C0.5,7.1354 1.171,6.4644 2,6.4644 Z M2,0 C2.829,0 3.5,0.671 3.5,1.5 C3.5,2.329 2.829,3 2,3 C1.171,3 0.5,2.329 0.5,1.5 C0.5,0.671 1.171,0 2,0 Z",
  id: "dot-menu-horizontal-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "dot-menu-horizontal-Icon/Global/Menu/Meatballsub",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "dot-menu-horizontal-Swatches/DarkGreen",
  transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) translate(10.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "dot-menu-horizontal-Mask",
  fill: "currentcolor",
  xlinkHref: "#dot-menu-horizontal-path-1"
})));

var SvgDotMenuHorizontal = function SvgDotMenuHorizontal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDotMenuHorizontal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dot-menu-horizontal.4f3f70e1.svg";
export { ForwardRef as ReactComponent };